import { render, staticRenderFns } from "./AddPriority.vue?vue&type=template&id=543892b4&"
import script from "./AddPriority.vue?vue&type=script&lang=js&"
export * from "./AddPriority.vue?vue&type=script&lang=js&"
import style0 from "./AddPriority.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports